import {
  CHECK_PARENT_SUCCESS,
  CHECK_PARENT_ERROR,
  CLEAN_SEARCH_PARENT
} from './actionTypes';
import parentApi from '../api/parentApi';

export const checkParentSuccess = parent => ({
  parent,
  type: CHECK_PARENT_SUCCESS
});

export const checkParentError = () => ({
  type: CHECK_PARENT_ERROR
});

export const cleanSearchParent = () => ({
  type: CLEAN_SEARCH_PARENT
});

export const checkParent = ci =>
  dispatch =>
    parentApi.checkParent({ ci }).then((response) => {
      dispatch(checkParentSuccess(response.parent));
    }).catch(() => {
      dispatch(checkParentError());
    });



// WEBPACK FOOTER //
// ./src/actions/parentActions.js